var OmasGlobalJsData = {
  Automatically_Refund: false,
  Automatically_Restock: true,
  CancelLineItemType: "request",
  redirectToCart: true,
  Button_Color: '#272d77',
  BtnTextColor: '#ffffff', 
  TimeLimit_Return_Day: '10',
  TimeLimit_Return_Hour: '0',
  TimeLimit_Return_Minute: '0',
  TimeLimit_Cancel_Day: '5',
  TimeLimit_Cancel_Hour: '0',
  TimeLimit_Cancel_Minute: '0',
  TimeZone: {},
  DailyFulfillment: {
    monday: false,
    mondayShour: '0',
    mondaySmin: '0',
    mondayEhour: '0',
    mondayEmin: '0',
    tuesday: false,
    tuesdayShour: '0',
    tuesdaySmin: '0',
    tuesdayEhour: '0',
    tuesdayEmin: '0',
    wednesday: false,
    wednesdayShour: '0',
    wednesdaySmin: '0',
    wednesdayEhour: '0',
    wednesdayEmin: '0',
    thursday: false,
    thursdayShour: '0',
    thursdaySmin: '0',
    thursdayEhour: '0',
    thursdayEmin: '0',
    friday: false,
    fridayShour: '0',
    fridaySmin: '0',
    fridayEhour: '0',
    fridayEmin: '0',
    saturday: false,
    saturdayShour: '0',
    saturdaySmin: '0',
    saturdayEhour: '0',
    saturdayEmin: '0',
    sunday: false,
    sundayShour: '0',
    sundaySmin: '0',
    sundayEhour: '0',
    sundayEmin: '0'
  },
  OrderCancelling: true,
  OrderEditing: true,
  displayLineItem: true,
  ReorderLineItemButtonText: 'Re-order Item',
  ReorderLineItemButtonTextColor: "#ffffff",
  ReorderLineItemButtonBgColor: "#3a3a3a",		
  ReorderLineItemButtonBorderColor: "#3a3a3a",
  ReorderLineItemButtonHoverBgColor: "#606060",
  ReorderButtonText: 'Re-order',
  ReorderButtonTextColor: "#ffffff",
  ReorderButtonBgColor: "#3a3a3a",				
  ReorderButtonBorderColor: "#3a3a3a",				
  ReorderButtonHoverBgColor: "#606060", 
  cancelOrderButtonText: 'Cancel Order',
  cancelOrderButtonTextColor: "#606060", 			
  cancelOrderButtonBgColor: "#ffffff",  		
  cancelOrderButtonBorderColor: "#3a3a3a",		    
  cancelOrderButtonHoverBgColor: "#ffffff",
  cancelLineItemButtonText: 'Cancel Item',
  cancelLineItemButtonTextColor: "#606060",	
  cancelLineItemButtonBgColor: "#ffffff",	
  cancelLineItemButtonBorderColor: "#3a3a3a",
  cancelLineItemButtonHoverBgColor: "#ffffff",
  EditLineItemButtonText: 'Edit Item',
  EditLineItemButtonTextColor: "#606060",			
  EditLineItemButtonBgColor: "#ffffff",		
  EditLineItemButtonBorderColor: "#3a3a3a",	
  EditLineItemButtonHoverBgColor: "#ffffff",
  cancelRequestLiButtonText: 'Cancel Request',
  cancelRequestLiButtonTextColor: "#606060",
  cancelRequestLiButtonBgColor: "#ffffff",
  cancelRequestLiButtonBorderColor: "#3a3a3a",
  cancelRequestLiButtonHoverBgColor: "#ffffff",
  returnRequestLiButtonText: 'Return Request',
  returnRequestLiButtonTextColor: "#606060",
  returnRequestLiButtonBgColor: "#ffffff",
  returnRequestLiButtonBorderColor: "#3a3a3a",
  returnRequestLiButtonHoverBgColor: "#ffffff"
}
